const styles = ({ COLORS }) => ({
  section: {
    borderBottom: 'none'
  },
  left: {
    textAlign: 'left'
  },
  intro: {
    fontSize: '16px',
    lineHeight: '22px',
    padding: '0 10px'
  },
  add: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginTop: '30px'
  },
  subsTable: {
    padding: '40px 60px',
    display: 'flex',
    background: '#f5f5f5c2',
    alignItems: 'center',
    borderRadius: '8px',
    justifyContent: 'space-between',
    marginBottom: '30px',
    marginTop: '40px',
    width: '98%',
    margin: '0 auto 30px',
    '& strong': {
      display: 'block',
      textAlign: 'center'
    }
  },
  subsStat: {
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center',
    '& strong': {
      fontSize: '28px',
      fontWeight: 'normal'
    }
  },
  iIcon: {
    color: COLORS.BLUE.NORMAL
  }
})

export default styles
